import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import ButtonAntd from '@deprecated-ui/common/Button';
import ModalAntd from '@deprecated-ui/common/Modal';
import InputAntd from '@deprecated-ui/common/Input';
import color from '@deprecated-ui/_style/color';
import { Table } from 'antd';

export const TemplateLayout = styled(Flex)`
  flex-direction: column;
  border: 1px solid ${color.gainsboro};
  border-radius: 4px;
  justify-content: center;
  max-width: 798px;
  background: white;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 100px;
`;

export const TemplateHeader = styled(Flex)`
  height: 52px;
  border-bottom: 1px solid ${color.gainsboro};
  width: 100%;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 135%;
`;

export const TemplateContent = styled(Flex)`
  padding: 40px;
  width: 100%;
`;

export const Input = styled(InputAntd).attrs({ p: '12px' })`
  width: 100% !important;
  border: 1px solid rgba(237, 237, 237, 1);
  border-radius: 4px;

  text-align: center;

  ${
    // @ts-expect-error
    ({ status }) => {
    if (status !== 'error') {
      return '';
    }
    return `
        border: 1px solid #EE4A49;

        &:hover,
        &:focus,
        &:active {
          border: 1px solid #EE4A49;
        }
      `;
  }}

  input {
    font-size: 14px;
    line-height: 19px;
    font-family: 'ProximaNovaLt';
    color: rgba(51, 51, 51, 1);

    &::placeholder {
      font-family: 'ProximaNovaLt';
      color: rgba(181, 181, 181, 1);
    }
  }
`;

export const ItemContainer = styled(Flex)`
  flex-direction: column;
  width: 100%;

  a {
    font-weight: bold;
  }

  .ant-btn-primary[disabled] {
    background-color: rgba(204, 238, 225, 1) !important;
  }
`;

export const FormContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  height: 520px;
  max-width: 400px;
  margin: auto;
  width: 100%;
`;

export const InfoWrapper = styled(Flex)`
  border-radius: 6px;
  background-color: rgba(242, 241, 254, 1);
  width: 100%;
`;

export const DetailContainer = styled(Flex)`
  flex-direction: column;
  width: 100%;
  height: 520px;
`;

export const FieldsetGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 40px;
`;

export const FieldsetWrapper = styled.fieldset<{ tight?: boolean }>`
  width: 100%;
  padding: ${({ tight }) => (tight ? '12px 16px' : '16px')};
  border: 1px solid rgba(237, 237, 237, 1);
  border-radius: 4px;

  .grey {
    color: rgba(181, 181, 181, 1);
  }

  .line-through {
    text-decoration: line-through;
  }
`;

export const Modal = styled(ModalAntd)`
  .ant-modal-content {
    border-radius: 3px;
    padding: 24px 40px 40px 40px;
  }
`;

export const Cancel = styled(ButtonAntd).attrs({
  type: 'link',
  radius: '4px',
  p: '12px',
  mr: '8px',
})`
  border: 1px solid rgba(237, 237, 237, 1);
`;

export const Next = styled(ButtonAntd).attrs({
  radius: '4px',
  p: '12px',
  mr: '8px',
  type: 'primary',
})`
  :disabled {
    background-color: #cceee1 !important;
  }
`;

export const DepositButton = styled(ButtonAntd).attrs({
  radius: '4px',
  mr: '0px',
  px: '12px',
  // @ts-expect-error
  type: 'outline-primary',
})``;

export const Exit = styled(ButtonAntd).attrs({
  type: 'link',
  radius: '4px',
  p: '12px',
  mr: '8px',
})`
  border: 1px solid rgba(238, 74, 73, 1);
  p {
    color: rgba(238, 74, 73, 1);
  }
`;

export const RefreshButton = styled(ButtonAntd).attrs({
  // @ts-expect-error
  type: 'button',
  radius: '0px',
  p: '0px',
})`
  border: none;
  outline: none;
`;

export const BalanceShimmer = styled.div`
  border-radius: 4px;
  height: 16px;
  width: 96px;
  background-color: #f7f7f7;
`;

interface MemberTableProps {
  alignSorter?: 'start' | 'end';
}

export const MemberTable = styled(Table)<MemberTableProps>`
  padding: 10px 12px;
  width: 100%;

  .ant-table-column-sorters-with-tooltip,
  .ant-table-column-sorters {
    display: flex;
    justify-content: ${({ alignSorter }) =>
      alignSorter === 'start' ? 'flex-start' : 'flex-end'};
    padding: 0;

    .ant-table-column-sorter {
      display: flex;
      margin-top: 0;
    }
  }

  & .ant-table {
    thead {
      th {
        background-color: transparent;
        padding: 6px 5px;
      }

      th:first-of-type {
        padding-left: 0;
      }

      th:last-of-type {
        padding-right: 0;
      }
    }

    tbody {
      td {
        overflow-wrap: normal;
        padding: 6px 5px;
      }

      td:first-of-type {
        padding-left: 0;
      }

      td:last-of-type {
        padding-right: 0;
      }
    }

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      border-bottom: 1px solid ${color.aliceBlue};
    }
  }
`;
